import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { FormProvider, useForm } from 'react-hook-form';
import { FormField } from '../../form/FormField';
import { IconButton, SearchFieldAlpha } from '@yonderland/andes-react';
import { MagnifyingGlassIcon } from '@yonderland/andes-icons';
export const initialValuesStoreFinder = {
    location: '',
};
export const StoreFinderForm = ({ initialValues, onSubmit, handleResetValues, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const formProps = useForm({
        defaultValues: initialValues,
        mode: 'onTouched',
    });
    const handleSubmit = (values) => {
        onSubmit(values, formProps.setError);
    };
    useEffect(() => {
        !!initialValues.location && formProps.setValue('location', initialValues.location);
    }, [initialValues]);
    return (_jsx(FormProvider, Object.assign({}, formProps, { children: _jsx("form", { onSubmit: formProps.handleSubmit(handleSubmit), noValidate: true, name: "store-finder-form-v2", autoComplete: "off", children: _jsx(FormField, { name: "location", children: (_a) => {
                    var _b = _a.fieldProps, { ref } = _b, options = __rest(_b, ["ref"]), { error } = _a;
                    return (_jsx(SearchFieldAlpha, Object.assign({ autoSearch: true }, options, { input: {
                            testId: 'store_finder_input',
                            id: 'store-finder-location',
                            name: 'location',
                            autoComplete: 'location',
                            placeholder: t('storeFinder.popup.placeholder'),
                            adornmentStart: (_jsx(IconButton, { testId: "store_finder_input_search", variant: "plain", size: "sm", icon: { source: MagnifyingGlassIcon }, type: "submit" })),
                            error,
                        }, onClear: () => {
                            formProps.setValue('location', '');
                            handleResetValues === null || handleResetValues === void 0 ? void 0 : handleResetValues();
                        } })));
                } }) }) })));
};
